import React from "react";

const WelcomeCard = () => {

  return (
    <>
      <p className="mb-0 hello">Hello,</p>
      <p className="welcomeTag mb-0">Welcome to VoltUp!</p>
      <p className="mb-0 hassle">
        <em>Hassle free battery exchange</em>
      </p>
      <p className="crmTextColor">
        <em>Anytime, Anywhere</em>
      </p>
    </>

  );
}

export default WelcomeCard;